import {Typography} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React from 'react'

import {classes} from '../PromoBannerButton.classes'
import type {Props} from './GetAppButton.types'

const Base: React.FC<Props> = ({onClick, text}) => (
  <button className={clsx(classes.button, classes.downloadButton)} onClick={onClick} type="button">
    <Typography color="invert" justifyContent="center" thickness="medium" variant="caption1">
      {text}
    </Typography>
  </button>
)

export const GetAppButton = React.memo(Base)
